export type StatusThemeMappings = 'incomplete' | 'submitted' | 'approved' | 'rejected' | 'skipped' | 'review';

export const StatusMappings = {
  'Waiting for Payment': 'Waiting for Payment',
  'Invoice Paid': 'Payment Complete',
  'Not Started': 'In Progress',
  'In Progress': 'In Progress',
  'In Progress - Delayed Info': 'In Progress - Additional Info Needed',
  'Ready for Review': 'In Internal Review',
  'In Review (internal)': 'In Final Review Process',
  'Revision Needed; Send Back to Reviewer': 'In Final Review Process',
  'Minor Revisions Needed; Submit to Client': 'In Final Review Process',
  'Send to Reviewer 2': 'In Final Review Process',
  'In Review 2': 'In Final Review Process',
  'Draft Submitted': 'Draft Submitted',
  'Client Changes Needed': 'Client Changes Requested',
  Complete: 'Final Report Submitted',
  'On Hold': 'On Hold Per Client',
  Canceled: 'Canceled By Client',
};

export type ReportStatus = keyof typeof StatusMappings;

export const StatusToColor: Record<ReportStatus, StatusThemeMappings> = {
  'Waiting for Payment': 'incomplete',
  'Invoice Paid': 'incomplete',
  'Not Started': 'submitted',
  'In Progress': 'submitted',
  'In Progress - Delayed Info': 'rejected',
  'Ready for Review': 'submitted',
  'In Review (internal)': 'submitted',
  'Revision Needed; Send Back to Reviewer': 'submitted',
  'Minor Revisions Needed; Submit to Client': 'submitted',
  'Send to Reviewer 2': 'submitted',
  'In Review 2': 'review',
  'Draft Submitted': 'review',
  'Client Changes Needed': 'submitted',
  Complete: 'approved',
  'On Hold': 'skipped',
  Canceled: 'rejected',
} as const;
